namespace RedBullMOBILE360.LoanWhitelist {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.LoanWhitelist.LoanWhitelistDialog')
    export class LoanWhitelistDialog extends Serenity.EntityDialog<LoanWhitelistRow, any> {
        protected getFormKey() { return LoanWhitelistForm.formKey; }
        protected getIdProperty() { return LoanWhitelistRow.idProperty; }
        protected getLocalTextPrefix() { return LoanWhitelistRow.localTextPrefix; }
        protected getNameProperty() { return LoanWhitelistRow.nameProperty; }
        protected getService() { return LoanWhitelistService.baseUrl; }
        protected getDeletePermission() { return LoanWhitelistRow.deletePermission; }
        protected getInsertPermission() { return LoanWhitelistRow.insertPermission; }
        protected getUpdatePermission() { return LoanWhitelistRow.updatePermission; }

        protected form = new LoanWhitelistForm(this.idPrefix);
    }
}